import React from "react";
import styled, { createGlobalStyle } from 'styled-components';
import I10n from '../features/i10n';
import AppTitle from '../atoms/app-title';
import MsxIcons from '../features/msx-icons';
import PropTypes from 'prop-types';
import SchneiderLogo from '../atoms/svg/schneider-logo';
import DropdownMenu from './dropdown_menu';
import InformationIcon from "../atoms/information-icon";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../color-constants";
import { appConfiguration } from '../utils/app-starter';
import Stepper from "./stepper";

const Container = styled.div`
  background-color: white;
  position: static;
  top: 0px;

  @media (max-width: 800px) {
    position: sticky;
    z-index: 300;
  }

  ${props => props.fullScreenEnabled && `
    position: sticky;
    z-index: 300;
  `}
`;

const HeaderContainer = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  color: white;
  background-color: ${SECONDARY_COLOR};
  @media (max-width: 800px) {
    display: flex;
    padding: 5px 16px;
  }
  ${props => props.fullScreenEnabled && `
    display: flex;
    padding: 5px 16px;
  `}
`;

const InformationContainer = styled.div`
  padding: 16px 16px 0 16px;
  background-color: ${props => {
    return props.isSoftwareLicenseConfiguration ? '#F4F4F4' : 'white';
  }};
`;


const SchneiderLogoWrapper = styled.div`
  width: 115px;
  height: 25px;
  cursor: pointer;
`;

const LoginAndReduceWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const LoginText = styled.span`
  font-size: 12px;
`;

const ReduceIconWrapper = styled.div`
  margin-left: 10px;
  cursor: pointer;
  @media (max-width: 800px) {
    display: none;
  }
`;

const ExpandRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TitleRow = styled(ExpandRow)`
  flex-wrap: wrap;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ExpandIconRow = styled(ExpandRow)`
  justify-content: flex-end;
`;

const StartPageIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  transform: scaleX(-1);
  border-left: 1px solid rgb(159, 160, 164);
  cursor: pointer;
  padding-left: 5px;
  margin-right: 5px;
  color: ${PRIMARY_COLOR};
`;

const ExpandIconWrapper = styled.div`
  cursor: pointer;
  @media (max-width: 800px) {
    display: none;
  }
  ${props => props.fullScreenEnabled && `
    display: none;
  `}
`;

const SeamlessProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 150px;
`;

const SeamlessProfileOption = styled.div`
  margin: 10px 0px;
  padding-left: 10px;
  cursor: pointer;
  border-left: 5px solid white;
  :hover {
    border-left: 5px solid #3dcd58;
  }
`;

const SeamlessProfileText = styled.span`
  font-size: 14px;
  color: #333;
`;

const SelectedCriteriaSpan = styled.span`
  font-weight: 400;
  font-size: 12px;
  margin-right: 5px;
`;

const SelectedCriteriaLink = styled.div`
  display: none;
  align-items: center;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
  @media (max-width: 800px) {
    display: flex;
  }
  :hover {
    ${SelectedCriteriaSpan} {
      text-decoration: underline;
    }
  }
`;

const SelectedCriteriaWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  margin-left: 10px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const CriteriaTitle = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #626469;
  white-space: nowrap;
`;

const CriteriaChip = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: ${props => props.marginLeft ? props.marginLeft : 0}px;
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : 0}px;
  border: 1px solid #9FA0A4;
  border-radius: 32px;
  padding: 0px 10px;
  color: #626469;
`;

const CriteriaChipText = styled.span`
  flex: 1 1 0px;
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
`;

const CriteriaHintIcon = styled.div`
  position: relative;
  margin-right: 5px;
  cursor: pointer;
  color: #9FA0A4;
`;

const CriteriaDeleteIcon = styled.div`
  position: relative;
  margin-left: 5px;
  cursor: pointer;
  ${props => props.color && `color: ${props.color};`}
`;

const FilterAppliedContent = styled.div`
  color: rgb(98,100,105);
  padding: 10px 10px 5px 10px;
`;

const FACTitle = styled.span`
  display: block !important;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 10px;
`;

const FacLabel = styled.span`
  display: block !important;
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 5px;
`;

const HomeAndTtitleWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const MobileModalLayer = styled.div`
  position: fixed;
  justify-content: center;
  align-items: center;
  display: flex;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
  background-color: rgba(51,51,51, 0.5);
  z-index: 100;
  color: #626469;
`;

const MobileModalWrapper = styled.div`
  background-color: white;
  padding: 10px 20px;
  width: 500px;
`;

const MobileModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom : 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 0px;
`;

const MobileModalTitle = styled.span`
  font-weight: 600;
  font-size: 20px;
`;

const ModalIconWrapper = styled.div`
  cursor: pointer;
`;

const MobileModalContent = styled.div`
  padding-top: 20px;
  display: inline-flex;
  flex-direction: column;
`;

const PrecommWarningWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #ec8d00;
  color: white;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 20px;
`;

const PrecommIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 22px;
  height: 22px;
  max-height: 22px;
  min-width: 22px;
  width: 22px;
  max-width: 22px;
  font-size: 16px;
  position: relative;
  z-index: 10000;
`;

const PrecommWarningLabel = styled.div`
  margin-left: 10px;
`;


class ApplicationFullHeader extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    shouldShowLogin: PropTypes.bool,
    fullScreenEnabled: PropTypes.bool,
    userName: PropTypes.string,
    goToStartPage: PropTypes.func,
    applicationParameters: PropTypes.object,
    setApplicationParameters: PropTypes.func,
    steps: PropTypes.array,
    activeStep: PropTypes.string,
    stepperActions: PropTypes.array,
    selectedCriteria: PropTypes.object,
    clearCategory: PropTypes.func,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    disabled: PropTypes.bool,
    mySchneiderLink: PropTypes.string,
    isSoftwareLicenseConfiguration: PropTypes.bool,
    showPrecommWarning: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      mobileShowFilter: false,
      applicationIsMounted: true
    };

    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;

    this._applicationExistenceChecker = setInterval(() => {
      if (document.getElementById('plc-application-header') == null) {
        this.updateStateIfMounted({applicationIsMounted: false});
        clearInterval(this._applicationExistenceChecker);
      }
    }, 500);
  }

  componentWillUnmount = () => {
    this._isMounted = false;
    if (this._applicationExistenceChecker) {
      clearInterval(this._applicationExistenceChecker);
    }
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  createStepsWithActions = () => {
    return this.props.steps.map((step, index) => {
      const action = this.props.stepperActions[index];

      return  {
        ...step,
        name: I10n.get(`app.stepper.${step.name}`),
        subLabel: this.getStepLabel(action.done, action.skipped, step.id === this.props.activeStep),
        isActive: step.id === this.props.activeStep,
        ...action
      };
    });
  }

  getStepLabel (isDone, isSkipped, isActiveStep) {
    let result = I10n.get('app.stepper.not_done');
    if (isSkipped) {
      result = I10n.get('app.stepper.skipped');
    } else if (isDone) {
      result = I10n.get('app.stepper.done');
    } else if (isActiveStep) {
      result = I10n.get('app.stepper.in_progress');
    }
    return result;
  }

  renderSeamlessProfileOptions = () => {
    return (
      <SeamlessProfileWrapper>
        {window.getUserMenuOptionsFromMySchneider().map((opt, idx) => {
          return (<SeamlessProfileOption key={idx} onClick={() => {
            opt.handler();
          }}>
            <SeamlessProfileText>
              {opt.label}
            </SeamlessProfileText>

          </SeamlessProfileOption>);
        })}
      </SeamlessProfileWrapper>
    );
  }

  renderFilterChips = (marginLeft, marginBottom, inModal = false) => {
    let rangeText = I10n.get('screen.start_configuration_screen.cbr.multiple_ranges');
    let referenceText = I10n.get('screen.start_configuration_screen.cbr.multiple_references');

    const selectedRanges = Object.keys(this.props.selectedCriteria?.ranges) || [];
    const selectedReferences = Object.keys(this.props.selectedCriteria?.references) || [];

    if (selectedRanges.length === 1) {
      rangeText = I10n.get(`category.${selectedRanges[0]}.name`, 'data');
    }

    if (selectedReferences.length === 1) {
      referenceText = selectedReferences[0];
    }

    return (
      <>
        {selectedRanges.length > 0 && <CriteriaChip marginLeft={marginLeft} marginBottom={marginBottom}>
          {selectedRanges.length > 1 && <CriteriaHintIcon>
            <DropdownMenu
              toggleElement={<InformationIcon></InformationIcon>}
              containerElement={<FilterAppliedContent>
                <FACTitle>{I10n.get('screen.start_configuration_screen.cbr.ranges')}</FACTitle>
                {selectedRanges.map((range, idx) => <FacLabel key={idx}>{I10n.get(`category.${range}.name`, 'data')}</FacLabel>)}
              </FilterAppliedContent>}
            >
            </DropdownMenu>
          </CriteriaHintIcon>}
          <CriteriaChipText>{rangeText}</CriteriaChipText>
          <CriteriaDeleteIcon color={inModal ? `${PRIMARY_COLOR}` : '#626469'} onClick={() => {
            this.props.clearCategory('ranges');
          }}>
            <MsxIcons name="modal-close"></MsxIcons>
          </CriteriaDeleteIcon>
        </CriteriaChip>}
        {selectedReferences.length > 0 && <CriteriaChip marginLeft={marginLeft} marginBottom={marginBottom}>
          {selectedReferences.length > 1 && <CriteriaHintIcon>
            <DropdownMenu
              toggleElement={<InformationIcon></InformationIcon>}
              containerElement={<FilterAppliedContent>
                <FACTitle>{I10n.get('screen.start_configuration_screen.cbr.references')}</FACTitle>
                {selectedReferences.map((ref, idx) => <FacLabel key={idx}>{ref}</FacLabel>)}
              </FilterAppliedContent>}
            >
            </DropdownMenu>
          </CriteriaHintIcon>}
          <CriteriaChipText>{referenceText}</CriteriaChipText>
          <CriteriaDeleteIcon color={inModal ? `${PRIMARY_COLOR}` : '#626469'} onClick={() => {
            this.props.clearCategory('references');
          }}>
            <MsxIcons name="modal-close"></MsxIcons>
          </CriteriaDeleteIcon>
        </CriteriaChip>}
      </>
    );
  }

  renderLoginWrapper = () => {
    return (
      <LoginWrapper onClick={() => { if (this.props.shouldShowLogin) { document.location.href = this.props.mySchneiderLink; } }}>
        <MsxIcons name="login"></MsxIcons>
        <LoginText>{this.props.shouldShowLogin ? I10n.get('app.action.login_register') : this.props.userName}</LoginText>
      </LoginWrapper>
    );
  }

  renderSelectedCriteria = () => {
    return (
      <>
        {this.state.mobileShowFilter && <MobileModalLayer>
          <MobileModalWrapper>
            <MobileModalHeader>
              <MobileModalTitle>
                {I10n.get('screen.start_configuration_screen.cbr.selected_criteria')}
              </MobileModalTitle>
              <ModalIconWrapper onClick={() => {
                this.setState({ mobileShowFilter: false });
              }}><MsxIcons name="modal-close"></MsxIcons></ModalIconWrapper>
            </MobileModalHeader>
            <MobileModalContent>
              {this.renderFilterChips(0, 10, true)}
            </MobileModalContent>
          </MobileModalWrapper>
        </MobileModalLayer>}
        <SelectedCriteriaLink onClick={() => {
          this.setState({ mobileShowFilter: true });
        }}>
          <SelectedCriteriaSpan>{I10n.get('screen.start_configuration_screen.cbr.view_selected_criteria')}</SelectedCriteriaSpan>
          <MsxIcons name="filter-link"></MsxIcons>
        </SelectedCriteriaLink>
        <SelectedCriteriaWrapper>
          <CriteriaTitle>
            {I10n.get('screen.start_configuration_screen.cbr.selected_criteria')} :
          </CriteriaTitle>
          {this.renderFilterChips(10, 0, false)}
        </SelectedCriteriaWrapper>
      </>


    );
  }

  render = () => {
    const GlobalStyles = createGlobalStyle`
      @media (max-width: 800px) {
        :root {
          overflow: hidden;
        }
      }
      ${props => props.fullScreenEnabled && `
        :root {
          overflow: hidden;
        }
      `}
    `;
    return (
      <Container id="plc-application-header" fullScreenEnabled={this.props.fullScreenEnabled}>
        {this.state.applicationIsMounted && <GlobalStyles fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}></GlobalStyles>}
        {window.top === window.self && <>
          <HeaderContainer fullScreenEnabled={this.props.fullScreenEnabled}>
            <SchneiderLogoWrapper onClick={() => {
                if (!appConfiguration.disableCallByRangeBackToStart) {
                  this.props.goToStartPage();
                }
              }}><SchneiderLogo></SchneiderLogo></SchneiderLogoWrapper>
            <LoginAndReduceWrapper>
              {(!this.props.shouldShowLogin && window.getUserMenuOptionsFromMySchneider) ?
                <DropdownMenu
                  forceLeft
                  data-clickable
                  toggleElement={this.renderLoginWrapper()}
                  containerElement={this.renderSeamlessProfileOptions()}
                >
                </DropdownMenu> :
                this.renderLoginWrapper()
              }
              <ReduceIconWrapper onClick={() => { this.props.setApplicationParameters({ fullScreenEnabled: false }); }}><MsxIcons name="reduce-full-screen"></MsxIcons></ReduceIconWrapper>
            </LoginAndReduceWrapper>
          </HeaderContainer>
          {this.props.fullScreenEnabled && <ExpandIconRow>
            <ExpandIconWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled} onClick={() => { this.props.setApplicationParameters({ fullScreenEnabled: true }); }}>
              <MsxIcons name="expand-full-screen" ></MsxIcons>
            </ExpandIconWrapper>
          </ExpandIconRow>}
        </>}
        <InformationContainer
        isSoftwareLicenseConfiguration={this.props.isSoftwareLicenseConfiguration}>
          {this.props.showPrecommWarning && <PrecommWarningWrapper>
            <PrecommIconWrapper>
              <qds-icon name={'exclamation-mark-triangle-solid'} size="medium">
              </qds-icon>
            </PrecommIconWrapper>
            <PrecommWarningLabel>
              {I10n.get('precommercialization_global_warning')}
            </PrecommWarningLabel>
          </PrecommWarningWrapper>}
          {window.top === window.self && this.props.fullScreenEnabled === false && <ExpandIconRow>
            <ExpandIconWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled} onClick={() => { this.props.setApplicationParameters({ fullScreenEnabled: true }); }}>
              <MsxIcons name="expand-full-screen" ></MsxIcons>
            </ExpandIconWrapper>
          </ExpandIconRow>}
          <TitleRow>
            <HomeAndTtitleWrapper>
              {!appConfiguration.disableCallByRangeBackToStart && <StartPageIconWrapper onClick={() => { this.props.goToStartPage(); }}>
                <MsxIcons name="go-to-start"></MsxIcons>
              </StartPageIconWrapper>}
              <ExpandRow>
                <AppTitle
                  title={this.props.title}
                  selectedLengthUnit={this.props.applicationParameters.lengthUnit}
                  setParameters={this.props.setApplicationParameters}
                ></AppTitle>
              </ExpandRow>
            </HomeAndTtitleWrapper>
            {this.props.selectedCriteria && ((this.props.selectedCriteria.references && Object.keys(this.props.selectedCriteria.references).length > 0) || (this.props.selectedCriteria.ranges && Object.keys(this.props.selectedCriteria.ranges).length > 0)) && this.renderSelectedCriteria()}
          </TitleRow>
          <Stepper
            steps={this.createStepsWithActions()}
            mobileBreakpoint={800}
            nanoMobileBreakpoint={650}
            nanoMobileMaxWidth={60}
            disabled={this.props.disabled}
            color={appConfiguration.globalStyles.secondaryColor}
          ></Stepper>

        </InformationContainer>
      </Container>
    );
  }
}

export default ApplicationFullHeader;
